import React, { Component } from 'react';

class LiveBet extends Component {
  render() {
    const SHOW_ON_FILTERS = ['SHOW_ONLY_SELECTED', 'SHOW_ONLY_LIVE'];
    // if( SHOW_ON_FILTERS.indexOf(this.props.showFilter) === -1 ) return null;

    return (
      <div style={SHOW_ON_FILTERS.indexOf(this.props.showFilter) === -1 ? {display: 'none'} : {}}>
        <div className="headline__arrow headline--darkblue headline__arrow-nospace">
          Προγνωστικά Live Betting
        </div>
        <div className="live-table-container">
          <table className="tips-table tips-table--paged tips-table--live" >
            <thead className="tips-table__header">
              <tr>
                <th>&nbsp;</th>
                <th>Δ</th>
                <th>ΚΩΔ.<br/>ΟΠΑΠ</th>
                <th>ΑΓΩΝΑΣ</th>
                <th>ΠΡΟΓΝΩΣΤΙΚΟ</th>
                <th>ΑΠΟΔ.<br/>ΠΟΝΤ.</th>
                <th>ΣΚΟΡ.<br/>+/-</th>
                <th>ΒΟΟΚ</th>
              </tr>
            </thead>
            <tbody className="tips-table__body">
              <tr>
                <td colSpan="8">
                  <span className="block-loader">
                    <svg className="circle-loader progress" width="22" height="22" version="1.1" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="8"/>
                    </svg>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
};

export default LiveBet;



// WEBPACK FOOTER //
// ./src/LiveBet.js